var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "security_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9af17",
    d: "M467.8 546l-5.3-5.3-83.5-83.5c-6.1-6.1-14.3-9.5-23-9.5s-16.8 3.4-23 9.5c-6.1 6.1-9.5 14.3-9.5 23s3.4 16.8 9.5 23L444.8 615c6.1 6.1 14.3 9.5 23 9.5s16.8-3.4 23-9.5L691 414.8c6.1-6.1 9.5-14.3 9.5-23s-3.4-16.8-9.5-23c-6.1-6.1-14.3-9.5-23-9.5s-16.8 3.4-23 9.5L473.1 540.7l-5.3 5.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M916.4 172.8L524.5 10c-4-1.6-8.2-2.5-12.5-2.5-4.3 0-8.5.8-12.5 2.5l-392 162.7c-12.2 5.1-20 16.8-20 30v197.8c0 66.3 9.9 132 29.3 195.2 19.1 61.9 47.1 120.6 83.2 174.4 36.2 53.8 79.9 101.9 130 143C381.2 955 438.3 989 499.7 1014c3.9 1.6 8 2.4 12.3 2.4s8.4-.8 12.3-2.4c61.4-25.1 118.5-59 169.6-100.9 50.1-41 93.8-89.1 130-143s64.2-112.5 83.2-174.4c19.5-63.2 29.3-128.8 29.3-195.2V202.8c0-13.2-7.8-25-20-30zm-44.9 56.7v171.1c0 57.9-8.4 115.4-24.9 170.8-16.4 54.6-40.3 106.6-71.3 154.4-63.5 97.9-153.5 174.5-260.3 221.6l-3 1.3-3-1.3c-52.6-23.2-101.6-53.8-145.5-91.1-43.4-36.8-81.2-79.6-112.5-127.1-64.4-97.7-98.4-211.3-98.4-328.5V224.5l4.6-1.9 352-146.1 2.9-1.2 2.9 1.2 352 146.1 4.6 1.9v5z"
  })));
}

export default SvgSecurity;